import { Button, Icons } from '@commenda/kakashi';
import {
  TaskStatus,
  TaskParty,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';

export const INC20AFilingTask = ({
  task,
  context,
  isTimelineView = false,
}: TCommonTaskProp) => {
  const { role, mutate } = context;

  const handleStepComplete = async () => {
    await updateTaskStatus({
      task,
      status: TaskStatus.COMPLETED,
      mutate,
    });
  };

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <div className="flex flex-col gap-2">
                <div className="text-sm text-gray-600 mb-2">
                  Please upload the required photographs for INC-20A filing:
                </div>
                <div className="text-sm space-y-2">
                  <div className="text-green-600">All photographs uploaded</div>
                  <div className="text-gray-600">
                    Commenda will now file INC-20A
                  </div>
                </div>
              </div>
            ),
            label: (
              <ServiceRequestTaskLabel label="INC-20A Filing in Progress" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="INC-20A filing completed successfully"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <div className="flex flex-col gap-2">
                <div className="text-sm text-gray-600 mb-2">Current step: </div>
                <div className="text-sm text-gray-600 mb-2">
                  Client has uploaded all required photographs. Ready to file
                  INC-20A.
                </div>
                <Button
                  size="sm"
                  onClick={handleStepComplete}
                  variant="primary"
                >
                  <Icons.Check className="size-4 mr-2" />
                  Mark INC-20A as Filed
                </Button>
              </div>
            ),
            label: (
              <ServiceRequestTaskLabel label="INC-20A Filing - Agent Action Required" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="INC-20A filing completed successfully"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
      };

      return (
        // Admin viewers run these steps too, and an unmapped role renders no actions.
        stateMap[state.role === TaskParty.ADMIN ? TaskParty.AGENT : state.role]?.[
          state.status
        ] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{ role, status: task.status }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
      />
    </div>
  );
};
